export default "__VITE_ASSET__DyUFBRnO__"